import axios from 'axios';

export const GET_LLM_CONFIG = 'GET_LLM_CONFIG';
export const ADD_LLM_CONFIG = 'ADD_LLM_CONFIG';
export const UPDATE_LLM_CONFIG = 'UPDATE_LLM_CONFIG';
export const DELETE_LLM_CONFIG = 'DELETE_LLM_CONFIG';

export const getLLMConfig = (botId) => async (dispatch) => {
  try {
    const response = await axios.get(`/api/llm-completion-config/${botId}`);
    dispatch({
      type: GET_LLM_CONFIG,
      payload: response.data
    });
  } catch (error) {
    console.error('Error getting LLM config:', error);
  }
};

export const addLLMConfig = (config) => async (dispatch) => {
  try {
    const response = await axios.post('/api/llm-completion-config', { config });
    dispatch({
      type: ADD_LLM_CONFIG,
      payload: response.data
    });
  } catch (error) {
    console.error('Error adding LLM config:', error);
  }
};

export const updateLLMConfig = (config) => async (dispatch) => {
  try {
    const response = await axios.put('/api/llm-completion-config', { config });
    dispatch({
      type: UPDATE_LLM_CONFIG,
      payload: response.data
    });
  } catch (error) {
    console.error('Error updating LLM config:', error);
  }
};

export const deleteLLMConfig = (id) => async (dispatch) => {
  try {
    await axios.delete(`/api/llm-completion-config/${id}`);
    dispatch({
      type: DELETE_LLM_CONFIG,
      payload: { id }
    });
  } catch (error) {
    console.error('Error deleting LLM config:', error);
  }
}; 